import { render, staticRenderFns } from "./OnboardingPage.vue?vue&type=template&id=34dfb5ce"
import script from "./OnboardingPage.vue?vue&type=script&lang=js"
export * from "./OnboardingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports